import { Autocomplete, Card, CardContent, CardHeader, CircularProgress, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, TextField } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography';
import { CustomDescrypt } from 'global/func';
import { postDataWithResponse } from 'global/postFunc';
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt';
import userStore from 'store/userStore';

const listBulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
];

const getPersenRealisasi = (realisasi, anggaran) => {
    let output = 0;
    if (anggaran === 0) {
        output = 0;
    }
    else {
        output = (realisasi / anggaran)
    }
    return output;
}

const StrukturAnggaran = () => {
    const { user, addReq, tahunAnggaran } = userStore(state => ({ user: state.user, addReq: state.addReq, tahunAnggaran: state.tahunAnggaran }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const reqStrukturAnggaran = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/sa/struktur-anggaran',
            {
                ta: tahunAnggaran.ta,
                kd_pd: opd.kd_pd
            },
            decryptedUser,
            (res) => {
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    const [opd, setOpd] = useState({})
    const [listOpd, setListOpd] = useState([])

    const reqOpd = () => {
        setLoading(true)
        postDataWithResponse(
            '/opd/filter',
            {
                jenis: '',
                nama: '',
            },
            null,
            (res) => {
                console.log(res);
                let semua = {
                    kd_pd: null,
                    nama_pd: 'SEMUA OPD'
                }
                setListOpd(res)
                setListOpd(listOpd => [semua, ...listOpd])
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqOpd()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [anggaranKas, setAnggarankas] = useState([])
    const [totalKeuangan, setTotalKeuangan] = useState(0)
    const [totalFisik, setTotalFisik] = useState(0)

    const reqAnggaranKas = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/anggaran-kas/filter',
            {
                ta: tahunAnggaran.ta,
                kd_pd: opd.kd_pd
            },
            decryptedUser,
            (res) => {
                setAnggarankas(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        if (anggaranKas.length > 0) {
            let x = 0;
            let y = 0;
            anggaranKas.forEach((rs) => {
                let z = parseFloat(rs.target_fisik.replace(',', '.')) * 100
                x += parseInt(rs.target_keuangan)
                y += z
            })
            setTotalKeuangan(x)
            setTotalFisik(y)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [anggaranKas])

    useEffect(() => {
        reqStrukturAnggaran()
        reqAnggaranKas()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opd])

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableBody>
                                <TableRow key={0} >
                                    <TableCell sx={{ fontSize: 'small' }}>Perangkat Daerah</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {decodedUser.kd_pd} {decodedUser.nm_pd}</TableCell>
                                </TableRow>
                                <TableRow key={1} >
                                    <TableCell sx={{ fontSize: 'small' }}>Tahun Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {tahunAnggaran.ta}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </ArgonBox>

            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Struktur Anggaran</ArgonTypography>
                        }
                    />
                    <CardContent>
                        <ArgonBox mb={1}>
                            <ArgonBox mb={1} ml={0.5}>
                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                    Pilih OPD
                                </ArgonTypography>
                            </ArgonBox>
                            <ArgonBox mb={1}>
                                <Autocomplete
                                    id="combo-box-demo"
                                    options={listOpd}
                                    fullWidth
                                    required
                                    getOptionLabel={(option) => option.nama_pd}
                                    onChange={(event, newValue) => {
                                        newValue !== null && setOpd(newValue)
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        newInputValue === "" && setOpd({})
                                        // newInputValue.length > 7 && reqDpt()
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            InputProps={{
                                                ...params.InputProps,
                                                required: true,
                                                endAdornment: (
                                                    <>
                                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </ArgonBox>
                        </ArgonBox>

                        {
                            loading ?
                                (
                                    <ArgonBox align="center">
                                        <CircularProgress />
                                    </ArgonBox>
                                )
                                :
                                (
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontSize: 'small' }}>No</TableCell>
                                                <TableCell sx={{ fontSize: 'small' }}>Uraian</TableCell>
                                                <TableCell sx={{ fontSize: 'small' }}>Anggaran</TableCell>
                                                <TableCell sx={{ fontSize: 'small' }}>Realisasi Keuangan</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                data.map((dt, index) => (
                                                    <TableRow key={index} >
                                                        <TableCell sx={{ fontSize: 'small', fontWeight: (dt.ket === 'KELOMPOK' || dt.ket === 'AKUN') && 'bold' }}>{dt.kode}</TableCell>
                                                        <TableCell sx={{ fontSize: 'small', fontWeight: (dt.ket === 'KELOMPOK' || dt.ket === 'AKUN') && 'bold' }}>
                                                            {dt.ket === 'KELOMPOK' ? <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> : dt.ket === 'JENIS' && <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>}{dt.uraian}
                                                        </TableCell>
                                                        <TableCell sx={{ fontSize: 'small', fontWeight: (dt.ket === 'KELOMPOK' || dt.ket === 'AKUN') && 'bold' }}>{dt.anggaran?.toLocaleString?.('id-ID', {
                                                            style: 'currency',
                                                            currency: 'IDR',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0,
                                                        })}</TableCell>
                                                        <TableCell sx={{ fontSize: 'small', fontWeight: (dt.ket === 'KELOMPOK' || dt.ket === 'AKUN') && 'bold' }}>
                                                            {dt.ru?.toLocaleString?.('id-ID', {
                                                                style: 'currency',
                                                                currency: 'IDR',
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0,
                                                            })} ({(getPersenRealisasi(dt.ru, dt.anggaran) * 100).toFixed(2)}%)
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>
                                    </Table>
                                )
                        }
                    </CardContent>
                </Card>
            </ArgonBox>

            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Anggaran Kas</ArgonTypography>
                        }
                    />
                    <CardContent>
                        {
                            loading ?
                                <ArgonBox align="center">
                                    <CircularProgress />
                                </ArgonBox>
                                :
                                <Table aria-label="simple table">
                                    <TableHead key={0}>
                                        <TableRow>
                                            <TableCell rowSpan={2} sx={{ fontSize: 'small' }}>No</TableCell>
                                            <TableCell rowSpan={2} sx={{ fontSize: 'small' }}>Bulan</TableCell>
                                            <TableCell colSpan={2} sx={{ fontSize: 'small', textAlign: 'center' }}>Target Realisasi Keuangan</TableCell>
                                            <TableCell rowSpan={2} sx={{ fontSize: 'small', textAlign: 'center' }}>Target Realisasi Fisik</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: 'small', textAlign: 'center' }}>Nominal</TableCell>
                                            <TableCell sx={{ fontSize: 'small', textAlign: 'center' }}>%</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            listBulan.map((bulan, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ fontSize: 'small' }}>{index + 1}</TableCell>
                                                    <TableCell sx={{ fontSize: 'small' }}>{bulan}</TableCell>
                                                    <TableCell sx={{ fontSize: 'small', textAlign: 'center' }}>{
                                                        anggaranKas[index]?.target_keuangan ?
                                                            parseInt(anggaranKas[index].target_keuangan)?.toLocaleString?.('id-ID', {
                                                                style: 'currency',
                                                                currency: 'IDR',
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0,
                                                            })
                                                            :
                                                            0
                                                    }</TableCell>
                                                    <TableCell sx={{ fontSize: 'small', textAlign: 'center' }}>{
                                                        anggaranKas[index]?.target_keuangan ?
                                                            ((parseInt(anggaranKas[index].target_keuangan) / totalKeuangan) * 100).toFixed(2) + '%'
                                                            :
                                                            0 + "%"

                                                    }</TableCell>
                                                    <TableCell sx={{ fontSize: 'small', textAlign: 'center' }}>{anggaranKas[index]?.target_fisik + '%' || ''}</TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell colSpan={2} sx={{ fontSize: 'small', fontWeight: 'bold' }}>Total</TableCell>
                                            <TableCell sx={{ fontSize: 'small', textAlign: 'center', fontWeight: 'bold' }}>{
                                                totalKeuangan.toLocaleString?.('id-ID', {
                                                    style: 'currency',
                                                    currency: 'IDR',
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                })
                                            }</TableCell>
                                            <TableCell sx={{ fontSize: 'small', textAlign: 'center', fontWeight: 'bold' }}>100%</TableCell>
                                            <TableCell sx={{ fontSize: 'small', textAlign: 'center', fontWeight: 'bold' }}>{totalFisik/100}%</TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                        }
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default StrukturAnggaran